<template>
  <header class="header">
<!--    <div class="header__logo-bg img-w">-->
<!--      <img src="@/assets/img/logo-bg.png" alt="">-->
<!--    </div>-->
    <iframe
      @load="showIframe = true"
      :class="{'-show' : showIframe}"
      class="header__logo-bg img-w" src="./canvas/canvas_v4.html" />
    <a href="https://lenta.ru/" target="_blank">
      <div class="header__logo img-w">
        <img src="@/assets/img/logo.png" alt="">
      </div>
    </a>
    <div class="burger" v-click-outside="closeMenu">
      <div @click="toggleMenu" class="burger__icon img-w">
        <img src="@/assets/img/burger.png" alt="">
      </div>
      <nav class="menu" :class="{'is-opened': menu}">
        <div class="menu__close img-w" @click="closeMenu">
          <img src="@/assets/img/x.png" alt="">
        </div>
        <div class="menu__wrapper">
          <vue-scroll :ops="ops">
            <a @click.prevent="go(`/article/${index+1}`)"
                         v-for="(link, index) in links"
                         :key="index">
              {{ link | typograf }}
              <div class="menu__arrow img-w">
                <img src="@/assets/img/arrow.png" alt="">
              </div>
            </a>
          </vue-scroll>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import './header.styl'
import './burger.styl'
import './menu.styl'

export default {
  name: 'Header',
  data () {
    return {
      showIframe: null,
      menu: false,
      ops: {
        onlyShowBarOnScroll: false,
        keepShow: true
      },
      links: [
        'В России миллионы матерей-одиночек с детьми. Как государство помогло им справиться с трудностями в жизни?',
        'От жестокости людей страдают тысячи животных. Как в России нашли способ их спасти?',
        'Миллионы россиян боялись потерять свои гаражи. Почему теперь такой опасности нет?',
        'Детей по всей России разлучали с братьями и сестрами в школах и детских садах. Как эту ситуацию удалось исправить?',
        'Миллионы россиян боялись брать больничный по уходу за ребенком. Почему теперь это изменится?',
        'Тысячи россиян не могли устроить детям летний отдых. Как власти нашли способ им помочь?',
        'Многие россияне отапливают свои дома дровами. Теперь к ним бесплатно проведут газ',
        'Тысячи российских фермеров не могли продать свои продукты. Как их спасло массовое открытие ярмарок?'
      ]
    }
  },
  methods: {
    toggleMenu () {
      this.menu = !this.menu

      if (this.menu) {
        this.$store.commit('LOCK_PAGE', true)
        this.$store.commit('LOCK_SCREEN_CHANGE')
      } else {
        this.$store.commit('LOCK_PAGE', false)
        this.$store.commit('UNLOCK_SCREEN_CHANGE')
      }
    },
    go (page) {
      this.closeMenu()
      this.$router.push(page)
    },
    closeMenu () {
      this.$store.commit('LOCK_PAGE', false)
      this.$store.commit('UNLOCK_SCREEN_CHANGE')
      this.menu = false
    }
  }
}
</script>

<style lang="stylus">
.__bar-is-vertical
  background: #fff !important

.__view
  padding-right: 2rem
  @media(max-width: 950px)
    padding-bottom: 6rem

.is-link-hidden
  display: none !important
</style>
